import * as types from '../../constants/log/gearMiningLogConstants';

export const gearMiningLogListRequest = ({
  page,
  pageLength,
  beginDate,
  endDate,
  account,
  postNo,
  callback,
  error,
}) => ({
  type: types.GEAR_MINING_LOG_LIST_REQUEST,
  page,
  pageLength,
  beginDate,
  endDate,
  account,
  postNo,
  callback,
  error,
});
